<template>
  <signup v-if="isAllowedToRegister"></signup>
  <simple v-else></simple>
</template>
<script>
import { default as signup } from './sign-in-sign-up.vue';
import { default as simple } from './sign-in-simple.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SignIn',
  components: {
    signup,
    simple
  },
  computed: {
    ...mapGetters({
      setup: 'credential/SETUP',
    }),
    isAllowedToRegister() {
      return this.setup?.settings?.allow_patient_to_register ?? false;
    },
  },
};
</script>
